import styled from "styled-components";

export const ContainerSection = styled.section`

  height: calc(100vh - 54px);
  overflow-y: scroll;
  margin-bottom: 90px;
 
  `;
export const Section = styled.div`
  width: 100%;
  height: auto;
  background-image: url("/fundo_branco.png");  
  background-size: cover;
  padding: 20px 20px 20px 20px;
  margin-bottom: 80px;
  box-sizing: border-box;
  
  @media (min-width: 768px) {
    margin-bottom: 0px;

  }
  @media (min-width: 1024px) {
    padding: 2.5rem;
    width: 100%;
    max-width: 1200px;
  }
  @media (min-width: 1240px) {
    border-radius: 14px;
    margin: 10px auto;
    border: 1px solid #2c2c2c;
  }
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
  @media (min-width: 1024px) {
    width: 100%;
  }
  @media (max-width: 1024px) {
    align-items: center;
    > hr {
      width: 90%;
    }
  }
`;
export const WrapperData = styled.div`
  padding: 10px;
  width: 100%;
  h1{
    text-align: center;
  }
`;
export const Wrapper = styled.div`
  padding: 10px;
  width: 280px;
  @media (min-width: 375px) {
    width: 350px;
  }
  @media (min-width: 425px) {
    width: 100%;
  }
  h1 {
    width: 100%;
    text-align: center;
  }
`;
export const OptionWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  border: 0.5 solid #355B94;
`;

interface OptionProps {
  selected: boolean;
  left?: boolean;
}
export const Option = styled.div<OptionProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0.5px solid #355B94;
  border-radius: ${({ left }) => (left ? "99px 0 0 99px" : "0 99px 99px 0")};
  background: ${({ selected }) => (selected ? "#355B94" : "#fff")};
  padding: 5px 10px;
  color: ${({ selected }) => (selected ? "#fff" : "#355B94")};
  cursor: pointer;
  > p {
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
`;
export const InputWrapper = styled.span`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.25rem;
  position: relative;
`;
export const InputContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 20px;
  gap: 20px;
  height: 100%;
  width: 100%;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
export const Label = styled.label`
  color: #2c2c2c;
  font-size: 16px;
  margin-left: 5px;
  font-family: "Archivo-Semibold";
`;
export const Input = styled.input`  
    color: #2c2c2c;
    font-size: medium;
    font-family: "Archivo-Regular";
    border: 1px solid #ccc;
    border-radius: 99px;
    height: 40px;
    padding: 0px 8px;
    width: 100%;
    &:focus {
      outline: none;
      border: 1px solid #000;
    }    
  
`;
export const ContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
  gap: 40px;
`;
interface ButtonProps {
  background: string;
  backgroundHover: string;
  color?: string;
}
export const Button = styled.button<ButtonProps>`
  background: ${({ background }) => background};
  padding: 10px 20px;
  width: fit-content;
  color: ${({ color }) => color ? color : "#fff"};
  text-transform: uppercase;
  border-radius: 99px;
  font-family: "Archivo-Regular";
  cursor: pointer;
  border: none;
  &:hover {
    background: ${({ backgroundHover }) => backgroundHover};
  }
`;
